import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import 'swiper/css/bundle';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
